import { InformationMessage } from "nemuru-components";
import React from "react";
import MainButton from "../../../../../../../../shared/components/MainButton";
import Text from "../../../../../../../../shared/components/Text";

export const TinkErrorMessage = ({ onPrev }) => {
  return (
    <>
      <InformationMessage
        className="information-message"
        variant={{
          type: "error",
          icon: (
            <i className="material-icons-outlined" style={{ fontSize: 26 }}>
              error
            </i>
          ),
        }}
        isScreenXs={false}
        messageContent={{
          title: <Text tId={"ERROR_BR_DEFAULT_TITLE"} />,
          body: <Text tId={"ERROR_BR_DEFAULT_TEXT"} />,
        }}
      />
      <MainButton color="secondary" onClick={onPrev}>
        <Text tId={"RETRY"} />
      </MainButton>
    </>
  );
};
